import { render, staticRenderFns } from "./index.home.vue?vue&type=template&id=6854ffa6&lang=pug"
import script from "./index.home.vue?vue&type=script&lang=js"
export * from "./index.home.vue?vue&type=script&lang=js"
import style0 from "./index.home.vue?vue&type=style&index=0&id=6854ffa6&prod&lang=stylus&socped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports